import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Logo1 from "./partials/Logo1";
import FooterSocial from "./partials/FooterSocial";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart } from "@fortawesome/free-solid-svg-icons";
const propTypes = {
  topOuterDivider: PropTypes.bool,
  topDivider: PropTypes.bool,
};

const defaultProps = {
  topOuterDivider: false,
  topDivider: false,
};

const Footer = ({ className, topOuterDivider, topDivider, ...props }) => {
  const classes = classNames(
    "site-footer center-content-mobile",
    topOuterDivider && "has-top-divider",
    className
  );

  return (
    <footer {...props} className={classes}>
      <div className="container">
        <div
          className={classNames(
            "site-footer-inner",
            topDivider && "has-top-divider"
          )}
        >
          <p style={{color: "#000"}}>Powered by,</p>
          <div className="footer-top space-between text-xxs">
            <Logo1 />
            <FooterSocial />
          </div>
          <div className="footer-bottom space-between text-xxs invert-order-desktop">
            {/* <FooterNav /> */}
            <div className="footer-copyright" style={{color: "#000"}}>
              Made with <FontAwesomeIcon icon={faHeart} color="red" /> in
              India..!
            </div>
          </div>
        </div>
      
       
       
      </div>
    </footer>
  );
};

Footer.propTypes = propTypes;
Footer.defaultProps = defaultProps;

export default Footer;
